export abstract class GenericRowSelectionFormManager {
    abstract onFormFieldChange(fieldProp, payload: any, options?): void;
    abstract resetFieldState(fieldProp): void;
}
